import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';


interface sourceList {
  sourceName: string;
  defaultSelected: string | number,
  optList: { label: string, value: string | number }[],
}
@Component({
  selector: 'bcac-bcac-source-group',
  templateUrl: './bcac-source-group.component.html',
  styleUrls: ['./bcac-source-group.component.scss']
})
export class BcacSourceGroupComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }


  dataSourceList 
  @Input()
  set bcacSelectList(sourceList: sourceList) {
    if (!_.isNil(sourceList)) {
      this.dataSourceList = sourceList
    }
  }

  @Output() bcacSelectedChange: EventEmitter<any> = new EventEmitter()
  sourceChange(e,sourceName) {
    const param = {
      sourceName: sourceName,
      selectedValue:e
    }
    this.bcacSelectedChange.emit(param);
  }

}
